// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { LoadPlanningControllerGetAllLoadPlanningsData, LoadPlanningControllerGetAllLoadPlanningsResponse, LoadPlanningControllerUpdateLoadPlanningData, LoadPlanningControllerUpdateLoadPlanningResponse, LoadPlanningControllerCreateLoadPlanningData, LoadPlanningControllerCreateLoadPlanningResponse, LoadAdjustmentsControllerSyncMeasureSimulationData, LoadAdjustmentsControllerSyncMeasureSimulationResponse, ProcurementControllerGetProcurementData, ProcurementControllerGetProcurementResponse, ProcurementControllerUpdateProcurementData, ProcurementControllerUpdateProcurementResponse, ProcurementControllerDeleteProcurementData, ProcurementControllerDeleteProcurementResponse, ProcurementControllerUpdateProcurementDataData, ProcurementControllerUpdateProcurementDataResponse, AdminTrancheFixingConfigControllerGetWorkflowsData, AdminTrancheFixingConfigControllerGetWorkflowsResponse, AdminTrancheFixingConfigControllerUpsertWorkflowData, AdminTrancheFixingConfigControllerUpsertWorkflowResponse, AdminReferencePriceControllerGetReferencePriceData, AdminReferencePriceControllerGetReferencePriceResponse, AdminReferencePriceControllerCreateOrUpdateReferencePriceData, AdminReferencePriceControllerCreateOrUpdateReferencePriceResponse, AdminReferencePriceControllerDeleteReferencePriceData, AdminReferencePriceControllerDeleteReferencePriceResponse, AdminCompanyFrontendConfigurationControllerCreateOrUpdateCompanyConfigurationData, AdminCompanyFrontendConfigurationControllerCreateOrUpdateCompanyConfigurationResponse, AdminCompanyFrontendConfigurationControllerDeleteCompanyConfigurationData, AdminCompanyFrontendConfigurationControllerDeleteCompanyConfigurationResponse, EnergySourcePriceControllerRetrieveAllEnergySourcePricesData, EnergySourcePriceControllerRetrieveAllEnergySourcePricesResponse, EnergySourcePriceControllerCreateOrUpdateEnergySourcePriceData, EnergySourcePriceControllerCreateOrUpdateEnergySourcePriceResponse, AdminCostModuleControllerGetData, AdminCostModuleControllerGetResponse, AdminCostModuleControllerUpsertData, AdminCostModuleControllerUpsertResponse, AdminUtilityContactConfigControllerGetUtilityContactInfosData, AdminUtilityContactConfigControllerGetUtilityContactInfosResponse, AdminUtilityContactConfigControllerUpsertUtilityInfosData, AdminUtilityContactConfigControllerUpsertUtilityInfosResponse, AdminCompanyTrackingAlgorithmOverrideControllerGetCompanyAlgorithmOverridesData, AdminCompanyTrackingAlgorithmOverrideControllerGetCompanyAlgorithmOverridesResponse, AdminCompanyTrackingAlgorithmOverrideControllerUpsertCompanyAlgorithmOverridesData, AdminCompanyTrackingAlgorithmOverrideControllerUpsertCompanyAlgorithmOverridesResponse, AdminCompanyNotificationConfigControllerGetCompanyNotificationConfigsData, AdminCompanyNotificationConfigControllerGetCompanyNotificationConfigsResponse, AdminCompanyNotificationConfigControllerUpsertCompanyNotificationConfigsData, AdminCompanyNotificationConfigControllerUpsertCompanyNotificationConfigsResponse, AdminStrategyNotificationConfigControllerGetStrategyNotificationConfigsData, AdminStrategyNotificationConfigControllerGetStrategyNotificationConfigsResponse, AdminStrategyNotificationConfigControllerUpsertStrategyNotificationConfigsData, AdminStrategyNotificationConfigControllerUpsertStrategyNotificationConfigsResponse, AdminCompanyHedgerConfigControllerGetCompanyHedgerConfigsData, AdminCompanyHedgerConfigControllerGetCompanyHedgerConfigsResponse, AdminCompanyHedgerConfigControllerUpsertCompanyHedgerConfigsData, AdminCompanyHedgerConfigControllerUpsertCompanyHedgerConfigsResponse, AdminCompanyFrontendConfigurationsControllerUpsertRetoolDashboardUrlData, AdminCompanyFrontendConfigurationsControllerUpsertRetoolDashboardUrlResponse, AdminCompanyFrontendConfigurationsControllerDeleteRetoolDashboardUrlData, AdminCompanyFrontendConfigurationsControllerDeleteRetoolDashboardUrlResponse, AdminCompanyFrontendConfigurationsControllerAddContactedStrategyData, AdminCompanyFrontendConfigurationsControllerAddContactedStrategyResponse, AdminCompanyFrontendConfigurationsControllerRemoveContactedStrategyData, AdminCompanyFrontendConfigurationsControllerRemoveContactedStrategyResponse, StrategySpecificReferencePriceControllerRetrieveAllStrategySpecificReferencePricesData, StrategySpecificReferencePriceControllerRetrieveAllStrategySpecificReferencePricesResponse, StrategySpecificReferencePriceControllerCreateData, StrategySpecificReferencePriceControllerCreateResponse, StrategySpecificReferencePriceControllerCreateOrUpdateStrategySpecificReferencePriceData, StrategySpecificReferencePriceControllerCreateOrUpdateStrategySpecificReferencePriceResponse, PortfolioOverviewControllerRequestUpdatePortfolioStrategyData, PortfolioOverviewControllerRequestUpdatePortfolioStrategyResponse, PortfolioOverviewControllerRequestPortfolioStrategyData, PortfolioOverviewControllerRequestPortfolioStrategyResponse, StrategyControllerUploadStrategyDocumentsData, StrategyControllerUploadStrategyDocumentsResponse, StaticStrategyControllerUploadStrategyDocumentsData, StaticStrategyControllerUploadStrategyDocumentsResponse, StaticStrategyControllerRetrieveAllStaticStrategiesData, StaticStrategyControllerRetrieveAllStaticStrategiesResponse, StaticStrategyControllerCreateStrategyData, StaticStrategyControllerCreateStrategyResponse, PlannedStrategyControllerRetrieveAllPlannedStrategiesData, PlannedStrategyControllerRetrieveAllPlannedStrategiesResponse, PlannedStrategyControllerCreatePlannedStrategyData, PlannedStrategyControllerCreatePlannedStrategyResponse, LoadPlanningControllerRequestLoadProfileDataData, LoadPlanningControllerRequestLoadProfileDataResponse, LoadPlanningControllerGetPreviewForecastData, LoadPlanningControllerGetPreviewForecastResponse, LoadAdjustmentsControllerFindAllRenewableProductionData, LoadAdjustmentsControllerFindAllRenewableProductionResponse, LoadAdjustmentsControllerCreateRenewableProductionData, LoadAdjustmentsControllerCreateRenewableProductionResponse, LoadAdjustmentsControllerFindAllReferenceBaseloadCorrectionData, LoadAdjustmentsControllerFindAllReferenceBaseloadCorrectionResponse, LoadAdjustmentsControllerCreateReferenceBaseloadCorrectionData, LoadAdjustmentsControllerCreateReferenceBaseloadCorrectionResponse, LoadAdjustmentsControllerFindAllPercentageQuantityData, LoadAdjustmentsControllerFindAllPercentageQuantityResponse, LoadAdjustmentsControllerCreatePercentageQuantityData, LoadAdjustmentsControllerCreatePercentageQuantityResponse, LoadAdjustmentsControllerFindAllFlexibilityData, LoadAdjustmentsControllerFindAllFlexibilityResponse, LoadAdjustmentsControllerCreateFlexibilityData, LoadAdjustmentsControllerCreateFlexibilityResponse, LoadAdjustmentsControllerFindAllCompanyHolidaysData, LoadAdjustmentsControllerFindAllCompanyHolidaysResponse, LoadAdjustmentsControllerCreateCompanyHolidaysData, LoadAdjustmentsControllerCreateCompanyHolidaysResponse, LoadAdjustmentsControllerFindAllAbsoluteQuantityData, LoadAdjustmentsControllerFindAllAbsoluteQuantityResponse, LoadAdjustmentsControllerCreateAbsoluteQuantityData, LoadAdjustmentsControllerCreateAbsoluteQuantityResponse, ProcurementControllerGetAllProcurementsData, ProcurementControllerGetAllProcurementsResponse, ProcurementControllerCreateProcurementData, ProcurementControllerCreateProcurementResponse, ProcurementControllerCreateProcurementWithDocumentsData, ProcurementControllerCreateProcurementWithDocumentsResponse, CustomReferenceBaseLoadControllerUploadCustomReferenceBaseLoadData, CustomReferenceBaseLoadControllerUploadCustomReferenceBaseLoadResponse, CustomReferenceBaseLoadControllerDeleteCustomReferenceBaseLoadData, CustomReferenceBaseLoadControllerDeleteCustomReferenceBaseLoadResponse, CostCalculationControllerCalculateData, CostCalculationControllerCalculateResponse, CostCalculationControllerCalculateCachedData, CostCalculationControllerCalculateCachedResponse, AdminTrancheControllerCreateTrancheData, AdminTrancheControllerCreateTrancheResponse, AdminTrancheFixingStatusControllerResetStatusData, AdminTrancheFixingStatusControllerResetStatusResponse, AdminStrategyControllerRetrieveAllStrategiesData, AdminStrategyControllerRetrieveAllStrategiesResponse, AdminStrategyControllerCreateStrategyData, AdminStrategyControllerCreateStrategyResponse, AdminStrategyControllerPublishHedgingSummaryData, AdminStrategyControllerPublishHedgingSummaryResponse, AdminPayAsContractedControllerPostData, AdminPayAsContractedControllerPostResponse, AdminPayAsContractedControllerGetPacHedgingSummaryData, AdminPayAsContractedControllerGetPacHedgingSummaryResponse, AdminPayAsContractedControllerSetPacHedgingSummaryData, AdminPayAsContractedControllerSetPacHedgingSummaryResponse, AdminPayAsContractedControllerCheckCsvData, AdminPayAsContractedControllerCheckCsvResponse, BordersBackfillControllerBackfillBordersData, BordersBackfillControllerBackfillBordersResponse, AdminProductControllerGetAllHorizontalProductsResponse, AdminProductControllerCreateHorizontalProductData, AdminProductControllerCreateHorizontalProductResponse, AdminPowerPurchasingAgreementControllerPostData, AdminPowerPurchasingAgreementControllerPostResponse, AdminPowerPurchasingAgreementControllerGetProductionData, AdminPowerPurchasingAgreementControllerGetProductionResponse, AdminPowerPurchasingAgreementControllerUploadProductionData, AdminPowerPurchasingAgreementControllerUploadProductionResponse, AdminOverviewEmailControllerSendOverviewEmailResponse, AdminOverviewEmailControllerSendSelfServiceOverviewEmailData, AdminOverviewEmailControllerSendSelfServiceOverviewEmailResponse, AdminPythonOptimizationControllerRunOptimizationData, AdminPythonOptimizationControllerRunOptimizationResponse, AdminPythonOptimizationControllerRunOptimizationPerStrategyData, AdminPythonOptimizationControllerRunOptimizationPerStrategyResponse, AdminPythonOptimizationControllerRunOptimizationPerCompanyData, AdminPythonOptimizationControllerRunOptimizationPerCompanyResponse, AdminGasSpotPriceControllerUploadSpotPricesData, AdminGasSpotPriceControllerUploadSpotPricesResponse, DevDataBackfillControllerReplicateRetoolHistoricPricesData, DevDataBackfillControllerReplicateRetoolHistoricPricesResponse, DevDataBackfillControllerReplicateRetoolBordersData, DevDataBackfillControllerReplicateRetoolBordersResponse, StaticStrategyControllerGetStaticStrategyData, StaticStrategyControllerGetStaticStrategyResponse, StaticStrategyControllerDeleteStrategyData, StaticStrategyControllerDeleteStrategyResponse, StaticStrategyControllerUpdateStrategyData, StaticStrategyControllerUpdateStrategyResponse, LoadAdjustmentsControllerFindRenewableProductionByIdData, LoadAdjustmentsControllerFindRenewableProductionByIdResponse, LoadAdjustmentsControllerUpdateRenewableProductionData, LoadAdjustmentsControllerUpdateRenewableProductionResponse, LoadAdjustmentsControllerFindReferenceBaseloadCorrectionByIdData, LoadAdjustmentsControllerFindReferenceBaseloadCorrectionByIdResponse, LoadAdjustmentsControllerUpdateReferenceBaseloadCorrectionData, LoadAdjustmentsControllerUpdateReferenceBaseloadCorrectionResponse, LoadAdjustmentsControllerFindPercentageQuantityByIdData, LoadAdjustmentsControllerFindPercentageQuantityByIdResponse, LoadAdjustmentsControllerUpdatePercentageQuantityData, LoadAdjustmentsControllerUpdatePercentageQuantityResponse, LoadAdjustmentsControllerFindFlexibilityByIdData, LoadAdjustmentsControllerFindFlexibilityByIdResponse, LoadAdjustmentsControllerUpdateFlexibilityData, LoadAdjustmentsControllerUpdateFlexibilityResponse, LoadAdjustmentsControllerFindCompanyHolidaysByIdData, LoadAdjustmentsControllerFindCompanyHolidaysByIdResponse, LoadAdjustmentsControllerUpdateCompanyHolidaysData, LoadAdjustmentsControllerUpdateCompanyHolidaysResponse, LoadAdjustmentsControllerFindAbsoluteQuantityByIdData, LoadAdjustmentsControllerFindAbsoluteQuantityByIdResponse, LoadAdjustmentsControllerUpdateAbsoluteQuantityData, LoadAdjustmentsControllerUpdateAbsoluteQuantityResponse, AdminTrancheControllerGetTrancheData, AdminTrancheControllerGetTrancheResponse, AdminTrancheControllerDeleteTrancheData, AdminTrancheControllerDeleteTrancheResponse, AdminTrancheControllerUpdateTrancheData, AdminTrancheControllerUpdateTrancheResponse, AdminTrancheFixingStatusControllerSetStatusData, AdminTrancheFixingStatusControllerSetStatusResponse, AdminStrategyControllerGetStrategyData, AdminStrategyControllerGetStrategyResponse, AdminStrategyControllerDeleteStrategyData, AdminStrategyControllerDeleteStrategyResponse, AdminStrategyControllerUpdateStrategyData, AdminStrategyControllerUpdateStrategyResponse, AdminPayAsContractedControllerGetPacData, AdminPayAsContractedControllerGetPacResponse, AdminPayAsContractedControllerDeleteData, AdminPayAsContractedControllerDeleteResponse, AdminPayAsContractedControllerUpdatePacData, AdminPayAsContractedControllerUpdatePacResponse, AdminProductControllerGetHorizontalProductData, AdminProductControllerGetHorizontalProductResponse, AdminProductControllerDeleteHorizontalProductData, AdminProductControllerDeleteHorizontalProductResponse, AdminProductControllerUpdateHorizontalProductData, AdminProductControllerUpdateHorizontalProductResponse, AdminPowerPurchasingAgreementControllerGetPpaData, AdminPowerPurchasingAgreementControllerGetPpaResponse, AdminPowerPurchasingAgreementControllerDeleteData, AdminPowerPurchasingAgreementControllerDeleteResponse, AdminPowerPurchasingAgreementControllerUpdateTrancheData, AdminPowerPurchasingAgreementControllerUpdateTrancheResponse, StrategyControllerRetrieveAllStrategiesData, StrategyControllerRetrieveAllStrategiesResponse, StrategyControllerGetStrategyData, StrategyControllerGetStrategyResponse, MarketTrackingControllerRetrieveMarketTrackingForAllProductsData, MarketTrackingControllerRetrieveMarketTrackingForAllProductsResponse, MarketTrackingControllerRetrieveMarketTrackingData, MarketTrackingControllerRetrieveMarketTrackingResponse, SavingsControllerGetData, SavingsControllerGetResponse, BorderControllerRetrieveBordersForIntervalData, BorderControllerRetrieveBordersForIntervalResponse, PortfolioOverviewControllerGetPortfolioTimeseriesData, PortfolioOverviewControllerGetPortfolioTimeseriesResponse, PortfolioOverviewControllerGetPortfolioOverviewData, PortfolioOverviewControllerGetPortfolioOverviewResponse, PortfolioOverviewControllerGetPortfolioDistributionData, PortfolioOverviewControllerGetPortfolioDistributionResponse, PortfolioOverviewControllerGetMonthlyDistributionData, PortfolioOverviewControllerGetMonthlyDistributionResponse, StrategyControllerGetStrategyDocumentsData, StrategyControllerGetStrategyDocumentsResponse, StrategyControllerDeleteStrategyDocumentsData, StrategyControllerDeleteStrategyDocumentsResponse, StrategyControllerFetchStrategyOverviewsData, StrategyControllerFetchStrategyOverviewsResponse, StaticStrategyControllerGetStaticStrategyDocumentsData, StaticStrategyControllerGetStaticStrategyDocumentsResponse, StaticStrategyControllerDeleteStaticStrategyDocumentsData, StaticStrategyControllerDeleteStaticStrategyDocumentsResponse, SpotPriceControllerGetSpotPriceCurveData, SpotPriceControllerGetSpotPriceCurveResponse, PricesControllerRetrievePricesData, PricesControllerRetrievePricesResponse, PricesControllerGetAllProductPricesData, PricesControllerGetAllProductPricesResponse, PlannedStrategyControllerRetrievePlannedStrategyData, PlannedStrategyControllerRetrievePlannedStrategyResponse, PlannedStrategyControllerDeletePlannedStrategyData, PlannedStrategyControllerDeletePlannedStrategyResponse, LoadPlanningControllerGetForecastData, LoadPlanningControllerGetForecastResponse, LoadPlanningControllerGetEarliestConsumptionPerLocationData, LoadPlanningControllerGetEarliestConsumptionPerLocationResponse, LoadAdjustmentsControllerFindAllAdjustmentsData, LoadAdjustmentsControllerFindAllAdjustmentsResponse, LoadAdjustmentsControllerFindAdjustmentsByMeasureSimulationData, LoadAdjustmentsControllerFindAdjustmentsByMeasureSimulationResponse, LoadAdjustmentsControllerFindAllMeasureSimulationCandidatesData, LoadAdjustmentsControllerFindAllMeasureSimulationCandidatesResponse, CompanyFrontendConfigurationControllerGetCompanyConfigurationData, CompanyFrontendConfigurationControllerGetCompanyConfigurationResponse, CompanyFrontendConfigurationsControllerGetCompanyConfigurationData, CompanyFrontendConfigurationsControllerGetCompanyConfigurationResponse, CompanyFrontendConfigurationsControllerGetRetoolDashboardUrlData, CompanyFrontendConfigurationsControllerGetRetoolDashboardUrlResponse, AdminTrancheFixingStatusControllerGetTrancheHistoryData, AdminTrancheFixingStatusControllerGetTrancheHistoryResponse, AdminTrancheFixingStatusControllerGetHistoryData, AdminTrancheFixingStatusControllerGetHistoryResponse, AdminTrancheFixingBoardControllerGetBoardData, AdminTrancheFixingBoardControllerGetBoardResponse, AdminStrategyControllerGetHedgedSummaryTimeseriesData, AdminStrategyControllerGetHedgedSummaryTimeseriesResponse, AdminProductControllerRetrieveTickerSymbolsResponse, AdminReferencePriceControllerRetrieveAllReferencePricesResponse, AdminCompanyFrontendConfigurationControllerGetAllCompanyConfigurationsResponse, AdminCompanyFrontendConfigurationsControllerGetAllCompanyConfigurationsResponse, AdminCompanyFrontendConfigurationsControllerGetRetoolDashboardUrlsData, AdminCompanyFrontendConfigurationsControllerGetRetoolDashboardUrlsResponse, AdminCompanyFrontendConfigurationsControllerGetContactedStrategiesData, AdminCompanyFrontendConfigurationsControllerGetContactedStrategiesResponse, LoadAdjustmentsControllerDeleteAdjustmentData, LoadAdjustmentsControllerDeleteAdjustmentResponse, AdminTrancheFixingConfigControllerDeleteWorkflowData, AdminTrancheFixingConfigControllerDeleteWorkflowResponse, EnergySourcePriceControllerDeleteEnergySourcePriceData, EnergySourcePriceControllerDeleteEnergySourcePriceResponse, AdminUtilityContactConfigControllerDeleteUtilityInfoData, AdminUtilityContactConfigControllerDeleteUtilityInfoResponse, AdminCompanyTrackingAlgorithmOverrideControllerDeleteCompanyAlgorithmOverrideData, AdminCompanyTrackingAlgorithmOverrideControllerDeleteCompanyAlgorithmOverrideResponse, AdminCompanyNotificationConfigControllerDeleteCompanyNotificationConfigData, AdminCompanyNotificationConfigControllerDeleteCompanyNotificationConfigResponse, AdminStrategyNotificationConfigControllerDeleteStrategyNotificationConfigData, AdminStrategyNotificationConfigControllerDeleteStrategyNotificationConfigResponse, AdminCompanyHedgerConfigControllerDeleteCompanyHedgerConfigData, AdminCompanyHedgerConfigControllerDeleteCompanyHedgerConfigResponse, AdminCompanyFrontendConfigurationsControllerDeleteCompanyConfigurationData, AdminCompanyFrontendConfigurationsControllerDeleteCompanyConfigurationResponse, AdminBuySignalNotificationControllerResetForTrancheData, AdminBuySignalNotificationControllerResetForTrancheResponse, AdminBuySignalNotificationControllerResetForStrategyData, AdminBuySignalNotificationControllerResetForStrategyResponse } from './types.gen';

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.year
 * @param data.energyType
 * @returns LoadPlanningWithStrategyDTO OK
 * @throws ApiError
 */
export const loadPlanningControllerGetAllLoadPlannings = (data: LoadPlanningControllerGetAllLoadPlanningsData): CancelablePromise<LoadPlanningControllerGetAllLoadPlanningsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning',
    query: {
        companyId: data.companyId,
        year: data.year,
        energyType: data.energyType
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.year
 * @param data.energyType
 * @param data.requestBody
 * @returns LoadPlanningWithStrategyDTO OK
 * @throws ApiError
 */
export const loadPlanningControllerUpdateLoadPlanning = (data: LoadPlanningControllerUpdateLoadPlanningData): CancelablePromise<LoadPlanningControllerUpdateLoadPlanningResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/api/procurement/load-planning',
    query: {
        companyId: data.companyId,
        year: data.year,
        energyType: data.energyType
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns LoadPlanningWithStrategyDTO Created
 * @throws ApiError
 */
export const loadPlanningControllerCreateLoadPlanning = (data: LoadPlanningControllerCreateLoadPlanningData): CancelablePromise<LoadPlanningControllerCreateLoadPlanningResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/load-planning',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.measureSimulationId
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerSyncMeasureSimulation = (data: LoadAdjustmentsControllerSyncMeasureSimulationData): CancelablePromise<LoadAdjustmentsControllerSyncMeasureSimulationResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/api/procurement/load-planning/adjustments/measure-simulation/{measureSimulationId}',
    path: {
        measureSimulationId: data.measureSimulationId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns ProcurementResponseDto OK
 * @throws ApiError
 */
export const procurementControllerGetProcurement = (data: ProcurementControllerGetProcurementData): CancelablePromise<ProcurementControllerGetProcurementResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/data/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns ProcurementResponseDto OK
 * @throws ApiError
 */
export const procurementControllerUpdateProcurement = (data: ProcurementControllerUpdateProcurementData): CancelablePromise<ProcurementControllerUpdateProcurementResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/api/procurement/data/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns unknown OK
 * @throws ApiError
 */
export const procurementControllerDeleteProcurement = (data: ProcurementControllerDeleteProcurementData): CancelablePromise<ProcurementControllerDeleteProcurementResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/procurement/data/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns ProcurementResponseDto OK
 * @throws ApiError
 */
export const procurementControllerUpdateProcurementData = (data: ProcurementControllerUpdateProcurementDataData): CancelablePromise<ProcurementControllerUpdateProcurementDataResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/api/procurement/data/{id}/fixed',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.utilityNames
 * @returns TrancheFixingConfigResponseDTO OK
 * @throws ApiError
 */
export const adminTrancheFixingConfigControllerGetWorkflows = (data: AdminTrancheFixingConfigControllerGetWorkflowsData = {}): CancelablePromise<AdminTrancheFixingConfigControllerGetWorkflowsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/tranche-fixing/config',
    query: {
        utilityNames: data.utilityNames
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns TrancheFixingWorkflowDTO OK
 * @throws ApiError
 */
export const adminTrancheFixingConfigControllerUpsertWorkflow = (data: AdminTrancheFixingConfigControllerUpsertWorkflowData): CancelablePromise<AdminTrancheFixingConfigControllerUpsertWorkflowResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/procurement/tranche-fixing/config',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.year
 * @param data.energyType
 * @returns ReferencePriceResponseDto OK
 * @throws ApiError
 */
export const adminReferencePriceControllerGetReferencePrice = (data: AdminReferencePriceControllerGetReferencePriceData): CancelablePromise<AdminReferencePriceControllerGetReferencePriceResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/prices/reference/{energy-type}/{year}',
    path: {
        year: data.year,
        'energy-type': data.energyType
    }
}); };

/**
 * @param data The data for the request.
 * @param data.year
 * @param data.energyType
 * @param data.requestBody
 * @returns ReferencePriceResponseDto OK
 * @throws ApiError
 */
export const adminReferencePriceControllerCreateOrUpdateReferencePrice = (data: AdminReferencePriceControllerCreateOrUpdateReferencePriceData): CancelablePromise<AdminReferencePriceControllerCreateOrUpdateReferencePriceResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/procurement/prices/reference/{energy-type}/{year}',
    path: {
        year: data.year,
        'energy-type': data.energyType
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.year
 * @param data.energyType
 * @returns void No Content
 * @throws ApiError
 */
export const adminReferencePriceControllerDeleteReferencePrice = (data: AdminReferencePriceControllerDeleteReferencePriceData): CancelablePromise<AdminReferencePriceControllerDeleteReferencePriceResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/prices/reference/{energy-type}/{year}',
    path: {
        year: data.year,
        'energy-type': data.energyType
    }
}); };

/**
 * @deprecated
 * @param data The data for the request.
 * @param data.companyId
 * @param data.requestBody
 * @returns CompanyConfigDto OK
 * @throws ApiError
 */
export const adminCompanyFrontendConfigurationControllerCreateOrUpdateCompanyConfiguration = (data: AdminCompanyFrontendConfigurationControllerCreateOrUpdateCompanyConfigurationData): CancelablePromise<AdminCompanyFrontendConfigurationControllerCreateOrUpdateCompanyConfigurationResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/procurement/frontendFlags/{companyId}',
    path: {
        companyId: data.companyId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @deprecated
 * @param data The data for the request.
 * @param data.companyId
 * @returns void No Content
 * @throws ApiError
 */
export const adminCompanyFrontendConfigurationControllerDeleteCompanyConfiguration = (data: AdminCompanyFrontendConfigurationControllerDeleteCompanyConfigurationData): CancelablePromise<AdminCompanyFrontendConfigurationControllerDeleteCompanyConfigurationResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/frontendFlags/{companyId}',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.energySource
 * @param data.year
 * @returns EnergySourcePriceDto OK
 * @throws ApiError
 */
export const energySourcePriceControllerRetrieveAllEnergySourcePrices = (data: EnergySourcePriceControllerRetrieveAllEnergySourcePricesData = {}): CancelablePromise<EnergySourcePriceControllerRetrieveAllEnergySourcePricesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/energy-source/reference',
    query: {
        energySource: data.energySource,
        year: data.year
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EnergySourcePriceDto OK
 * @throws ApiError
 */
export const energySourcePriceControllerCreateOrUpdateEnergySourcePrice = (data: EnergySourcePriceControllerCreateOrUpdateEnergySourcePriceData): CancelablePromise<EnergySourcePriceControllerCreateOrUpdateEnergySourcePriceResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/procurement/energy-source/reference',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.year
 * @param data.energyType
 * @param data.locationId
 * @param data.buildingId
 * @param data.meteringType
 * @returns CostModuleScopeResponseDTO OK
 * @throws ApiError
 */
export const adminCostModuleControllerGet = (data: AdminCostModuleControllerGetData): CancelablePromise<AdminCostModuleControllerGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/cost-modules/company/{companyId}',
    path: {
        companyId: data.companyId
    },
    query: {
        year: data.year,
        energyType: data.energyType,
        locationId: data.locationId,
        buildingId: data.buildingId,
        meteringType: data.meteringType
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.requestBody
 * @returns CostModuleScopeResponseDTO OK
 * @throws ApiError
 */
export const adminCostModuleControllerUpsert = (data: AdminCostModuleControllerUpsertData): CancelablePromise<AdminCostModuleControllerUpsertResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/procurement/cost-modules/company/{companyId}',
    path: {
        companyId: data.companyId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.utilityNames
 * @returns UtilityInfoDto OK
 * @throws ApiError
 */
export const adminUtilityContactConfigControllerGetUtilityContactInfos = (data: AdminUtilityContactConfigControllerGetUtilityContactInfosData = {}): CancelablePromise<AdminUtilityContactConfigControllerGetUtilityContactInfosResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/config/utility',
    query: {
        utilityNames: data.utilityNames
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns UtilityInfoDto OK
 * @throws ApiError
 */
export const adminUtilityContactConfigControllerUpsertUtilityInfos = (data: AdminUtilityContactConfigControllerUpsertUtilityInfosData): CancelablePromise<AdminUtilityContactConfigControllerUpsertUtilityInfosResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/procurement/config/utility',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyIds
 * @returns CompanyTrackingAlgorithmOverrideDto OK
 * @throws ApiError
 */
export const adminCompanyTrackingAlgorithmOverrideControllerGetCompanyAlgorithmOverrides = (data: AdminCompanyTrackingAlgorithmOverrideControllerGetCompanyAlgorithmOverridesData = {}): CancelablePromise<AdminCompanyTrackingAlgorithmOverrideControllerGetCompanyAlgorithmOverridesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/config/tracking-algorithm-overrides',
    query: {
        companyIds: data.companyIds
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CompanyTrackingAlgorithmOverrideDto OK
 * @throws ApiError
 */
export const adminCompanyTrackingAlgorithmOverrideControllerUpsertCompanyAlgorithmOverrides = (data: AdminCompanyTrackingAlgorithmOverrideControllerUpsertCompanyAlgorithmOverridesData): CancelablePromise<AdminCompanyTrackingAlgorithmOverrideControllerUpsertCompanyAlgorithmOverridesResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/procurement/config/tracking-algorithm-overrides',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyIds
 * @returns CompanyNotificationConfigDto OK
 * @throws ApiError
 */
export const adminCompanyNotificationConfigControllerGetCompanyNotificationConfigs = (data: AdminCompanyNotificationConfigControllerGetCompanyNotificationConfigsData = {}): CancelablePromise<AdminCompanyNotificationConfigControllerGetCompanyNotificationConfigsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/config/notifications',
    query: {
        companyIds: data.companyIds
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CompanyNotificationConfigDto OK
 * @throws ApiError
 */
export const adminCompanyNotificationConfigControllerUpsertCompanyNotificationConfigs = (data: AdminCompanyNotificationConfigControllerUpsertCompanyNotificationConfigsData): CancelablePromise<AdminCompanyNotificationConfigControllerUpsertCompanyNotificationConfigsResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/procurement/config/notifications',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyIds
 * @returns StrategyNotificationConfigDto OK
 * @throws ApiError
 */
export const adminStrategyNotificationConfigControllerGetStrategyNotificationConfigs = (data: AdminStrategyNotificationConfigControllerGetStrategyNotificationConfigsData = {}): CancelablePromise<AdminStrategyNotificationConfigControllerGetStrategyNotificationConfigsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/config/notifications/strategies',
    query: {
        companyIds: data.companyIds
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns StrategyNotificationConfigDto OK
 * @throws ApiError
 */
export const adminStrategyNotificationConfigControllerUpsertStrategyNotificationConfigs = (data: AdminStrategyNotificationConfigControllerUpsertStrategyNotificationConfigsData): CancelablePromise<AdminStrategyNotificationConfigControllerUpsertStrategyNotificationConfigsResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/procurement/config/notifications/strategies',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyIds
 * @returns CompanyHedgerConfigDto OK
 * @throws ApiError
 */
export const adminCompanyHedgerConfigControllerGetCompanyHedgerConfigs = (data: AdminCompanyHedgerConfigControllerGetCompanyHedgerConfigsData = {}): CancelablePromise<AdminCompanyHedgerConfigControllerGetCompanyHedgerConfigsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/config/hedger',
    query: {
        companyIds: data.companyIds
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CompanyHedgerConfigDto OK
 * @throws ApiError
 */
export const adminCompanyHedgerConfigControllerUpsertCompanyHedgerConfigs = (data: AdminCompanyHedgerConfigControllerUpsertCompanyHedgerConfigsData): CancelablePromise<AdminCompanyHedgerConfigControllerUpsertCompanyHedgerConfigsResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/procurement/config/hedger',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.requestBody
 * @returns CompanyConfigDto OK
 * @throws ApiError
 */
export const adminCompanyFrontendConfigurationsControllerUpsertRetoolDashboardUrl = (data: AdminCompanyFrontendConfigurationsControllerUpsertRetoolDashboardUrlData): CancelablePromise<AdminCompanyFrontendConfigurationsControllerUpsertRetoolDashboardUrlResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/procurement/company-frontend-configurations/{companyId}/retool-dashboard-url',
    path: {
        companyId: data.companyId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns void No Content
 * @throws ApiError
 */
export const adminCompanyFrontendConfigurationsControllerDeleteRetoolDashboardUrl = (data: AdminCompanyFrontendConfigurationsControllerDeleteRetoolDashboardUrlData): CancelablePromise<AdminCompanyFrontendConfigurationsControllerDeleteRetoolDashboardUrlResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/company-frontend-configurations/{companyId}/retool-dashboard-url',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.strategyId
 * @returns CompanyConfigDto OK
 * @throws ApiError
 */
export const adminCompanyFrontendConfigurationsControllerAddContactedStrategy = (data: AdminCompanyFrontendConfigurationsControllerAddContactedStrategyData): CancelablePromise<AdminCompanyFrontendConfigurationsControllerAddContactedStrategyResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/admin/procurement/company-frontend-configurations/{companyId}/contacted-strategies/{strategyId}',
    path: {
        companyId: data.companyId,
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.strategyId
 * @returns void No Content
 * @throws ApiError
 */
export const adminCompanyFrontendConfigurationsControllerRemoveContactedStrategy = (data: AdminCompanyFrontendConfigurationsControllerRemoveContactedStrategyData): CancelablePromise<AdminCompanyFrontendConfigurationsControllerRemoveContactedStrategyResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/company-frontend-configurations/{companyId}/contacted-strategies/{strategyId}',
    path: {
        companyId: data.companyId,
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns ReferencePriceOverrideDTO OK
 * @throws ApiError
 */
export const strategySpecificReferencePriceControllerRetrieveAllStrategySpecificReferencePrices = (data: StrategySpecificReferencePriceControllerRetrieveAllStrategySpecificReferencePricesData): CancelablePromise<StrategySpecificReferencePriceControllerRetrieveAllStrategySpecificReferencePricesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/strategies/{strategyId}/reference-prices',
    path: {
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.requestBody
 * @returns ReferencePriceOverrideDTO OK
 * @throws ApiError
 */
export const strategySpecificReferencePriceControllerCreate = (data: StrategySpecificReferencePriceControllerCreateData): CancelablePromise<StrategySpecificReferencePriceControllerCreateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/strategies/{strategyId}/reference-prices',
    path: {
        strategyId: data.strategyId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.requestBody
 * @returns ReferencePriceOverrideDTO OK
 * @throws ApiError
 */
export const strategySpecificReferencePriceControllerCreateOrUpdateStrategySpecificReferencePrice = (data: StrategySpecificReferencePriceControllerCreateOrUpdateStrategySpecificReferencePriceData): CancelablePromise<StrategySpecificReferencePriceControllerCreateOrUpdateStrategySpecificReferencePriceResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/api/procurement/strategies/{strategyId}/reference-prices',
    path: {
        strategyId: data.strategyId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Created
 * @throws ApiError
 */
export const portfolioOverviewControllerRequestUpdatePortfolioStrategy = (data: PortfolioOverviewControllerRequestUpdatePortfolioStrategyData): CancelablePromise<PortfolioOverviewControllerRequestUpdatePortfolioStrategyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/strategies/{strategyId}/portfolio/request-update-strategy',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Created
 * @throws ApiError
 */
export const portfolioOverviewControllerRequestPortfolioStrategy = (data: PortfolioOverviewControllerRequestPortfolioStrategyData): CancelablePromise<PortfolioOverviewControllerRequestPortfolioStrategyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/strategies/{strategyId}/portfolio/request-strategy',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.formData
 * @returns StrategyResponseDTO OK
 * @throws ApiError
 */
export const strategyControllerUploadStrategyDocuments = (data: StrategyControllerUploadStrategyDocumentsData): CancelablePromise<StrategyControllerUploadStrategyDocumentsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/strategies/{strategyId}/documents',
    path: {
        strategyId: data.strategyId
    },
    formData: data.formData,
    mediaType: 'multipart/form-data'
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.formData
 * @returns StaticStrategyResponseDTO OK
 * @throws ApiError
 */
export const staticStrategyControllerUploadStrategyDocuments = (data: StaticStrategyControllerUploadStrategyDocumentsData): CancelablePromise<StaticStrategyControllerUploadStrategyDocumentsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/static/strategies/{strategyId}/documents',
    path: {
        strategyId: data.strategyId
    },
    formData: data.formData,
    mediaType: 'multipart/form-data'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns StaticStrategyResponseDTO OK
 * @throws ApiError
 */
export const staticStrategyControllerRetrieveAllStaticStrategies = (data: StaticStrategyControllerRetrieveAllStaticStrategiesData): CancelablePromise<StaticStrategyControllerRetrieveAllStaticStrategiesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/static/strategies/',
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns StaticStrategyResponseDTO Created
 * @throws ApiError
 */
export const staticStrategyControllerCreateStrategy = (data: StaticStrategyControllerCreateStrategyData): CancelablePromise<StaticStrategyControllerCreateStrategyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/static/strategies/',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns PlannedStrategyResponseDTO OK
 * @throws ApiError
 */
export const plannedStrategyControllerRetrieveAllPlannedStrategies = (data: PlannedStrategyControllerRetrieveAllPlannedStrategiesData): CancelablePromise<PlannedStrategyControllerRetrieveAllPlannedStrategiesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/planned/strategies',
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PlannedStrategyResponseDTO OK
 * @throws ApiError
 */
export const plannedStrategyControllerCreatePlannedStrategy = (data: PlannedStrategyControllerCreatePlannedStrategyData): CancelablePromise<PlannedStrategyControllerCreatePlannedStrategyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/planned/strategies',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Created
 * @throws ApiError
 */
export const loadPlanningControllerRequestLoadProfileData = (data: LoadPlanningControllerRequestLoadProfileDataData): CancelablePromise<LoadPlanningControllerRequestLoadProfileDataResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/load-planning/request-load-profile',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.year
 * @param data.energyType
 * @param data.requestBody
 * @param data.locationId
 * @param data.includeHourlyResults
 * @param data.include15MinResults
 * @returns ForecastPreviewResponseDto OK
 * @throws ApiError
 */
export const loadPlanningControllerGetPreviewForecast = (data: LoadPlanningControllerGetPreviewForecastData): CancelablePromise<LoadPlanningControllerGetPreviewForecastResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/load-planning/forecasts/preview',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        year: data.year,
        energyType: data.energyType,
        includeHourlyResults: data.includeHourlyResults,
        include15MinResults: data.include15MinResults
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.year
 * @param data.energyType
 * @param data.locationId
 * @param data.status
 * @returns RenewableProductionAdjustmentResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerFindAllRenewableProduction = (data: LoadAdjustmentsControllerFindAllRenewableProductionData): CancelablePromise<LoadAdjustmentsControllerFindAllRenewableProductionResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/adjustments/renewable-production',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        year: data.year,
        energyType: data.energyType,
        status: data.status
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns RenewableProductionAdjustmentResponseDTO Created
 * @throws ApiError
 */
export const loadAdjustmentsControllerCreateRenewableProduction = (data: LoadAdjustmentsControllerCreateRenewableProductionData): CancelablePromise<LoadAdjustmentsControllerCreateRenewableProductionResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/load-planning/adjustments/renewable-production',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.year
 * @param data.energyType
 * @param data.locationId
 * @param data.status
 * @returns ReferenceBaseloadCorrectionAdjustmentResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerFindAllReferenceBaseloadCorrection = (data: LoadAdjustmentsControllerFindAllReferenceBaseloadCorrectionData): CancelablePromise<LoadAdjustmentsControllerFindAllReferenceBaseloadCorrectionResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/adjustments/reference-baseload-correction',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        year: data.year,
        energyType: data.energyType,
        status: data.status
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ReferenceBaseloadCorrectionAdjustmentResponseDTO Created
 * @throws ApiError
 */
export const loadAdjustmentsControllerCreateReferenceBaseloadCorrection = (data: LoadAdjustmentsControllerCreateReferenceBaseloadCorrectionData): CancelablePromise<LoadAdjustmentsControllerCreateReferenceBaseloadCorrectionResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/load-planning/adjustments/reference-baseload-correction',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.year
 * @param data.energyType
 * @param data.locationId
 * @param data.status
 * @returns PercentageQuantityAdjustmentResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerFindAllPercentageQuantity = (data: LoadAdjustmentsControllerFindAllPercentageQuantityData): CancelablePromise<LoadAdjustmentsControllerFindAllPercentageQuantityResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/adjustments/percentage-quantity',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        year: data.year,
        energyType: data.energyType,
        status: data.status
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PercentageQuantityAdjustmentResponseDTO Created
 * @throws ApiError
 */
export const loadAdjustmentsControllerCreatePercentageQuantity = (data: LoadAdjustmentsControllerCreatePercentageQuantityData): CancelablePromise<LoadAdjustmentsControllerCreatePercentageQuantityResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/load-planning/adjustments/percentage-quantity',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.year
 * @param data.energyType
 * @param data.locationId
 * @param data.status
 * @returns FlexibilityAdjustmentResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerFindAllFlexibility = (data: LoadAdjustmentsControllerFindAllFlexibilityData): CancelablePromise<LoadAdjustmentsControllerFindAllFlexibilityResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/adjustments/flexibility',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        year: data.year,
        energyType: data.energyType,
        status: data.status
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns FlexibilityAdjustmentResponseDTO Created
 * @throws ApiError
 */
export const loadAdjustmentsControllerCreateFlexibility = (data: LoadAdjustmentsControllerCreateFlexibilityData): CancelablePromise<LoadAdjustmentsControllerCreateFlexibilityResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/load-planning/adjustments/flexibility',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.year
 * @param data.energyType
 * @param data.locationId
 * @param data.status
 * @returns CompanyHolidaysResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerFindAllCompanyHolidays = (data: LoadAdjustmentsControllerFindAllCompanyHolidaysData): CancelablePromise<LoadAdjustmentsControllerFindAllCompanyHolidaysResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/adjustments/company-holidays',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        year: data.year,
        energyType: data.energyType,
        status: data.status
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CompanyHolidaysResponseDTO Created
 * @throws ApiError
 */
export const loadAdjustmentsControllerCreateCompanyHolidays = (data: LoadAdjustmentsControllerCreateCompanyHolidaysData): CancelablePromise<LoadAdjustmentsControllerCreateCompanyHolidaysResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/load-planning/adjustments/company-holidays',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.year
 * @param data.energyType
 * @param data.locationId
 * @param data.status
 * @returns AbsoluteQuantityAdjustmentResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerFindAllAbsoluteQuantity = (data: LoadAdjustmentsControllerFindAllAbsoluteQuantityData): CancelablePromise<LoadAdjustmentsControllerFindAllAbsoluteQuantityResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/adjustments/absolute-quantity',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        year: data.year,
        energyType: data.energyType,
        status: data.status
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AbsoluteQuantityAdjustmentResponseDTO Created
 * @throws ApiError
 */
export const loadAdjustmentsControllerCreateAbsoluteQuantity = (data: LoadAdjustmentsControllerCreateAbsoluteQuantityData): CancelablePromise<LoadAdjustmentsControllerCreateAbsoluteQuantityResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/load-planning/adjustments/absolute-quantity',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.locationId
 * @param data.companyId
 * @returns ProcurementResponseDto OK
 * @throws ApiError
 */
export const procurementControllerGetAllProcurements = (data: ProcurementControllerGetAllProcurementsData = {}): CancelablePromise<ProcurementControllerGetAllProcurementsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/data',
    query: {
        locationId: data.locationId,
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ProcurementResponseDto OK
 * @throws ApiError
 */
export const procurementControllerCreateProcurement = (data: ProcurementControllerCreateProcurementData): CancelablePromise<ProcurementControllerCreateProcurementResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/data',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.year
 * @param data.energyType
 * @param data.companyId
 * @param data.locationId
 * @param data.supplier
 * @param data.contractName
 * @param data.userId
 * @param data.fixedPrice
 * @param data.spotshare
 * @param data.formData
 * @returns ProcurementCreationResponseDto OK
 * @throws ApiError
 */
export const procurementControllerCreateProcurementWithDocuments = (data: ProcurementControllerCreateProcurementWithDocumentsData): CancelablePromise<ProcurementControllerCreateProcurementWithDocumentsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/data/documents',
    query: {
        year: data.year,
        energyType: data.energyType,
        companyId: data.companyId,
        locationId: data.locationId,
        supplier: data.supplier,
        fixedPrice: data.fixedPrice,
        spotshare: data.spotshare,
        contractName: data.contractName,
        userId: data.userId
    },
    formData: data.formData,
    mediaType: 'multipart/form-data'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.year
 * @param data.energyType
 * @param data.locationId
 * @param data.referenceDate
 * @param data.formData
 * @returns WebAsyncTaskUnit OK
 * @throws ApiError
 */
export const customReferenceBaseLoadControllerUploadCustomReferenceBaseLoad = (data: CustomReferenceBaseLoadControllerUploadCustomReferenceBaseLoadData): CancelablePromise<CustomReferenceBaseLoadControllerUploadCustomReferenceBaseLoadResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/custom-reference-base-loads',
    query: {
        companyId: data.companyId,
        year: data.year,
        energyType: data.energyType,
        locationId: data.locationId,
        referenceDate: data.referenceDate
    },
    formData: data.formData,
    mediaType: 'multipart/form-data'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.year
 * @param data.energyType
 * @returns void No Content
 * @throws ApiError
 */
export const customReferenceBaseLoadControllerDeleteCustomReferenceBaseLoad = (data: CustomReferenceBaseLoadControllerDeleteCustomReferenceBaseLoadData): CancelablePromise<CustomReferenceBaseLoadControllerDeleteCustomReferenceBaseLoadResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/procurement/custom-reference-base-loads',
    query: {
        companyId: data.companyId,
        year: data.year,
        energyType: data.energyType
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CostCalculationResultDTO OK
 * @throws ApiError
 */
export const costCalculationControllerCalculate = (data: CostCalculationControllerCalculateData): CancelablePromise<CostCalculationControllerCalculateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/cost-calculations',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.forceRefresh
 * @returns CostCalculationResultDTO OK
 * @throws ApiError
 */
export const costCalculationControllerCalculateCached = (data: CostCalculationControllerCalculateCachedData): CancelablePromise<CostCalculationControllerCalculateCachedResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/procurement/cost-calculations/cached',
    query: {
        forceRefresh: data.forceRefresh
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns TrancheResponseDTO OK
 * @throws ApiError
 */
export const adminTrancheControllerCreateTranche = (data: AdminTrancheControllerCreateTrancheData): CancelablePromise<AdminTrancheControllerCreateTrancheResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/tranches',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns StatusChangeResponseDTO OK
 * @throws ApiError
 */
export const adminTrancheFixingStatusControllerResetStatus = (data: AdminTrancheFixingStatusControllerResetStatusData): CancelablePromise<AdminTrancheFixingStatusControllerResetStatusResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/tranche-fixing/statuses/reset',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns AdminStrategyResponseDTO OK
 * @throws ApiError
 */
export const adminStrategyControllerRetrieveAllStrategies = (data: AdminStrategyControllerRetrieveAllStrategiesData): CancelablePromise<AdminStrategyControllerRetrieveAllStrategiesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/strategies',
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AdminStrategyResponseDTO OK
 * @throws ApiError
 */
export const adminStrategyControllerCreateStrategy = (data: AdminStrategyControllerCreateStrategyData): CancelablePromise<AdminStrategyControllerCreateStrategyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/strategies',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns string No Content
 * @throws ApiError
 */
export const adminStrategyControllerPublishHedgingSummary = (data: AdminStrategyControllerPublishHedgingSummaryData): CancelablePromise<AdminStrategyControllerPublishHedgingSummaryResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/strategies/{strategyId}/propagate-hedged-summary',
    path: {
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.requestBody
 * @returns WebAsyncTaskPayAsContractedAgreementResponseDTO OK
 * @throws ApiError
 */
export const adminPayAsContractedControllerPost = (data: AdminPayAsContractedControllerPostData): CancelablePromise<AdminPayAsContractedControllerPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/strategies/{strategyId}/pacs',
    path: {
        strategyId: data.strategyId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.pacId
 * @returns HedgingDataPointDTO OK
 * @throws ApiError
 */
export const adminPayAsContractedControllerGetPacHedgingSummary = (data: AdminPayAsContractedControllerGetPacHedgingSummaryData): CancelablePromise<AdminPayAsContractedControllerGetPacHedgingSummaryResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/strategies/{strategyId}/pacs/{pacId}/hedging-summary',
    path: {
        strategyId: data.strategyId,
        pacId: data.pacId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.pacId
 * @param data.requestBody
 * @returns WebAsyncTaskUnit OK
 * @throws ApiError
 */
export const adminPayAsContractedControllerSetPacHedgingSummary = (data: AdminPayAsContractedControllerSetPacHedgingSummaryData): CancelablePromise<AdminPayAsContractedControllerSetPacHedgingSummaryResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/strategies/{strategyId}/pacs/{pacId}/hedging-summary',
    path: {
        strategyId: data.strategyId,
        pacId: data.pacId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns WebAsyncTaskCsvValidationResponseDTO OK
 * @throws ApiError
 */
export const adminPayAsContractedControllerCheckCsv = (data: AdminPayAsContractedControllerCheckCsvData = {}): CancelablePromise<AdminPayAsContractedControllerCheckCsvResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/strategies/{strategyId}/pacs/csv-check',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.requestBody
 * @returns WebAsyncTaskBordersBackfillResponseDto OK
 * @throws ApiError
 */
export const bordersBackfillControllerBackfillBorders = (data: BordersBackfillControllerBackfillBordersData): CancelablePromise<BordersBackfillControllerBackfillBordersResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/strategies/{strategyId}/borders/backfill',
    path: {
        strategyId: data.strategyId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @returns HorizontalProductResponseDto OK
 * @throws ApiError
 */
export const adminProductControllerGetAllHorizontalProducts = (): CancelablePromise<AdminProductControllerGetAllHorizontalProductsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/products/horizontal'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns HorizontalProductResponseDto OK
 * @throws ApiError
 */
export const adminProductControllerCreateHorizontalProduct = (data: AdminProductControllerCreateHorizontalProductData): CancelablePromise<AdminProductControllerCreateHorizontalProductResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/products/horizontal',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PowerPurchasingAgreementResponseDTO OK
 * @throws ApiError
 */
export const adminPowerPurchasingAgreementControllerPost = (data: AdminPowerPurchasingAgreementControllerPostData): CancelablePromise<AdminPowerPurchasingAgreementControllerPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/ppas',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.ppaId
 * @param data.targetGranularity
 * @returns PpaProductionDataPointDTO OK
 * @throws ApiError
 */
export const adminPowerPurchasingAgreementControllerGetProduction = (data: AdminPowerPurchasingAgreementControllerGetProductionData): CancelablePromise<AdminPowerPurchasingAgreementControllerGetProductionResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/ppas/{ppaId}/production',
    path: {
        ppaId: data.ppaId
    },
    query: {
        targetGranularity: data.targetGranularity
    }
}); };

/**
 * @param data The data for the request.
 * @param data.ppaId
 * @param data.requestBody
 * @returns WebAsyncTaskUnit OK
 * @throws ApiError
 */
export const adminPowerPurchasingAgreementControllerUploadProduction = (data: AdminPowerPurchasingAgreementControllerUploadProductionData): CancelablePromise<AdminPowerPurchasingAgreementControllerUploadProductionResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/ppas/{ppaId}/production',
    path: {
        ppaId: data.ppaId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @returns void No Content
 * @throws ApiError
 */
export const adminOverviewEmailControllerSendOverviewEmail = (): CancelablePromise<AdminOverviewEmailControllerSendOverviewEmailResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/overview-email'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns void No Content
 * @throws ApiError
 */
export const adminOverviewEmailControllerSendSelfServiceOverviewEmail = (data: AdminOverviewEmailControllerSendSelfServiceOverviewEmailData): CancelablePromise<AdminOverviewEmailControllerSendSelfServiceOverviewEmailResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/overview-email/self-service/{companyId}',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns WebAsyncTaskOptimizationResponseDTO OK
 * @throws ApiError
 */
export const adminPythonOptimizationControllerRunOptimization = (data: AdminPythonOptimizationControllerRunOptimizationData): CancelablePromise<AdminPythonOptimizationControllerRunOptimizationResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/optimization/run',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns AdminOptimizationRunResultDTO OK
 * @throws ApiError
 */
export const adminPythonOptimizationControllerRunOptimizationPerStrategy = (data: AdminPythonOptimizationControllerRunOptimizationPerStrategyData): CancelablePromise<AdminPythonOptimizationControllerRunOptimizationPerStrategyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/optimization/run/strategy/{strategyId}',
    path: {
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns AdminOptimizationRunResultDTO OK
 * @throws ApiError
 */
export const adminPythonOptimizationControllerRunOptimizationPerCompany = (data: AdminPythonOptimizationControllerRunOptimizationPerCompanyData): CancelablePromise<AdminPythonOptimizationControllerRunOptimizationPerCompanyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/optimization/run/company/{companyId}',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns WebAsyncTaskUnit OK
 * @throws ApiError
 */
export const adminGasSpotPriceControllerUploadSpotPrices = (data: AdminGasSpotPriceControllerUploadSpotPricesData = {}): CancelablePromise<AdminGasSpotPriceControllerUploadSpotPricesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/procurement/gas-spot-prices',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @deprecated
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ReplicationResponseDto OK
 * @throws ApiError
 */
export const devDataBackfillControllerReplicateRetoolHistoricPrices = (data: DevDataBackfillControllerReplicateRetoolHistoricPricesData): CancelablePromise<DevDataBackfillControllerReplicateRetoolHistoricPricesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/backfill/historic-prices',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @deprecated
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ReplicationResponseDto OK
 * @throws ApiError
 */
export const devDataBackfillControllerReplicateRetoolBorders = (data: DevDataBackfillControllerReplicateRetoolBordersData): CancelablePromise<DevDataBackfillControllerReplicateRetoolBordersResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/admin/backfill/borders',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns StaticStrategyResponseDTO OK
 * @throws ApiError
 */
export const staticStrategyControllerGetStaticStrategy = (data: StaticStrategyControllerGetStaticStrategyData): CancelablePromise<StaticStrategyControllerGetStaticStrategyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/static/strategies/{strategyId}',
    path: {
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns string No Content
 * @throws ApiError
 */
export const staticStrategyControllerDeleteStrategy = (data: StaticStrategyControllerDeleteStrategyData): CancelablePromise<StaticStrategyControllerDeleteStrategyResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/procurement/static/strategies/{strategyId}',
    path: {
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.requestBody
 * @returns StaticStrategyResponseDTO OK
 * @throws ApiError
 */
export const staticStrategyControllerUpdateStrategy = (data: StaticStrategyControllerUpdateStrategyData): CancelablePromise<StaticStrategyControllerUpdateStrategyResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/api/procurement/static/strategies/{strategyId}',
    path: {
        strategyId: data.strategyId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.status
 * @returns RenewableProductionAdjustmentResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerFindRenewableProductionById = (data: LoadAdjustmentsControllerFindRenewableProductionByIdData): CancelablePromise<LoadAdjustmentsControllerFindRenewableProductionByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/adjustments/renewable-production/{id}',
    path: {
        id: data.id
    },
    query: {
        status: data.status
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns RenewableProductionAdjustmentResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerUpdateRenewableProduction = (data: LoadAdjustmentsControllerUpdateRenewableProductionData): CancelablePromise<LoadAdjustmentsControllerUpdateRenewableProductionResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/api/procurement/load-planning/adjustments/renewable-production/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.status
 * @returns ReferenceBaseloadCorrectionAdjustmentResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerFindReferenceBaseloadCorrectionById = (data: LoadAdjustmentsControllerFindReferenceBaseloadCorrectionByIdData): CancelablePromise<LoadAdjustmentsControllerFindReferenceBaseloadCorrectionByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/adjustments/reference-baseload-correction/{id}',
    path: {
        id: data.id
    },
    query: {
        status: data.status
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns ReferenceBaseloadCorrectionAdjustmentResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerUpdateReferenceBaseloadCorrection = (data: LoadAdjustmentsControllerUpdateReferenceBaseloadCorrectionData): CancelablePromise<LoadAdjustmentsControllerUpdateReferenceBaseloadCorrectionResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/api/procurement/load-planning/adjustments/reference-baseload-correction/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.status
 * @returns PercentageQuantityAdjustmentResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerFindPercentageQuantityById = (data: LoadAdjustmentsControllerFindPercentageQuantityByIdData): CancelablePromise<LoadAdjustmentsControllerFindPercentageQuantityByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/adjustments/percentage-quantity/{id}',
    path: {
        id: data.id
    },
    query: {
        status: data.status
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns PercentageQuantityAdjustmentResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerUpdatePercentageQuantity = (data: LoadAdjustmentsControllerUpdatePercentageQuantityData): CancelablePromise<LoadAdjustmentsControllerUpdatePercentageQuantityResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/api/procurement/load-planning/adjustments/percentage-quantity/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.status
 * @returns FlexibilityAdjustmentResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerFindFlexibilityById = (data: LoadAdjustmentsControllerFindFlexibilityByIdData): CancelablePromise<LoadAdjustmentsControllerFindFlexibilityByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/adjustments/flexibility/{id}',
    path: {
        id: data.id
    },
    query: {
        status: data.status
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns FlexibilityAdjustmentResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerUpdateFlexibility = (data: LoadAdjustmentsControllerUpdateFlexibilityData): CancelablePromise<LoadAdjustmentsControllerUpdateFlexibilityResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/api/procurement/load-planning/adjustments/flexibility/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.status
 * @returns CompanyHolidaysResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerFindCompanyHolidaysById = (data: LoadAdjustmentsControllerFindCompanyHolidaysByIdData): CancelablePromise<LoadAdjustmentsControllerFindCompanyHolidaysByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/adjustments/company-holidays/{id}',
    path: {
        id: data.id
    },
    query: {
        status: data.status
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns CompanyHolidaysResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerUpdateCompanyHolidays = (data: LoadAdjustmentsControllerUpdateCompanyHolidaysData): CancelablePromise<LoadAdjustmentsControllerUpdateCompanyHolidaysResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/api/procurement/load-planning/adjustments/company-holidays/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.status
 * @returns AbsoluteQuantityAdjustmentResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerFindAbsoluteQuantityById = (data: LoadAdjustmentsControllerFindAbsoluteQuantityByIdData): CancelablePromise<LoadAdjustmentsControllerFindAbsoluteQuantityByIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/adjustments/absolute-quantity/{id}',
    path: {
        id: data.id
    },
    query: {
        status: data.status
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns AbsoluteQuantityAdjustmentResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerUpdateAbsoluteQuantity = (data: LoadAdjustmentsControllerUpdateAbsoluteQuantityData): CancelablePromise<LoadAdjustmentsControllerUpdateAbsoluteQuantityResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/api/procurement/load-planning/adjustments/absolute-quantity/{id}',
    path: {
        id: data.id
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.trancheId
 * @returns TrancheResponseDTO OK
 * @throws ApiError
 */
export const adminTrancheControllerGetTranche = (data: AdminTrancheControllerGetTrancheData): CancelablePromise<AdminTrancheControllerGetTrancheResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/tranches/{trancheId}',
    path: {
        trancheId: data.trancheId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.trancheId
 * @returns string No Content
 * @throws ApiError
 */
export const adminTrancheControllerDeleteTranche = (data: AdminTrancheControllerDeleteTrancheData): CancelablePromise<AdminTrancheControllerDeleteTrancheResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/tranches/{trancheId}',
    path: {
        trancheId: data.trancheId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.trancheId
 * @param data.requestBody
 * @returns TrancheResponseDTO OK
 * @throws ApiError
 */
export const adminTrancheControllerUpdateTranche = (data: AdminTrancheControllerUpdateTrancheData): CancelablePromise<AdminTrancheControllerUpdateTrancheResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/admin/procurement/tranches/{trancheId}',
    path: {
        trancheId: data.trancheId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns StatusChangeResponseDTO OK
 * @throws ApiError
 */
export const adminTrancheFixingStatusControllerSetStatus = (data: AdminTrancheFixingStatusControllerSetStatusData): CancelablePromise<AdminTrancheFixingStatusControllerSetStatusResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/admin/procurement/tranche-fixing/statuses',
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns AdminStrategyResponseDTO OK
 * @throws ApiError
 */
export const adminStrategyControllerGetStrategy = (data: AdminStrategyControllerGetStrategyData): CancelablePromise<AdminStrategyControllerGetStrategyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/strategies/{strategyId}',
    path: {
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns string No Content
 * @throws ApiError
 */
export const adminStrategyControllerDeleteStrategy = (data: AdminStrategyControllerDeleteStrategyData): CancelablePromise<AdminStrategyControllerDeleteStrategyResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/strategies/{strategyId}',
    path: {
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.requestBody
 * @returns AdminStrategyResponseDTO OK
 * @throws ApiError
 */
export const adminStrategyControllerUpdateStrategy = (data: AdminStrategyControllerUpdateStrategyData): CancelablePromise<AdminStrategyControllerUpdateStrategyResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/admin/procurement/strategies/{strategyId}',
    path: {
        strategyId: data.strategyId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.pacId
 * @returns PayAsContractedAgreementResponseDTO OK
 * @throws ApiError
 */
export const adminPayAsContractedControllerGetPac = (data: AdminPayAsContractedControllerGetPacData): CancelablePromise<AdminPayAsContractedControllerGetPacResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/strategies/{strategyId}/pacs/{pacId}',
    path: {
        strategyId: data.strategyId,
        pacId: data.pacId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.pacId
 * @returns void No Content
 * @throws ApiError
 */
export const adminPayAsContractedControllerDelete = (data: AdminPayAsContractedControllerDeleteData): CancelablePromise<AdminPayAsContractedControllerDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/strategies/{strategyId}/pacs/{pacId}',
    path: {
        strategyId: data.strategyId,
        pacId: data.pacId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.pacId
 * @param data.requestBody
 * @returns WebAsyncTaskPayAsContractedAgreementResponseDTO OK
 * @throws ApiError
 */
export const adminPayAsContractedControllerUpdatePac = (data: AdminPayAsContractedControllerUpdatePacData): CancelablePromise<AdminPayAsContractedControllerUpdatePacResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/admin/procurement/strategies/{strategyId}/pacs/{pacId}',
    path: {
        strategyId: data.strategyId,
        pacId: data.pacId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.symbol
 * @returns HorizontalProductResponseDto OK
 * @throws ApiError
 */
export const adminProductControllerGetHorizontalProduct = (data: AdminProductControllerGetHorizontalProductData): CancelablePromise<AdminProductControllerGetHorizontalProductResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/products/horizontal/{symbol}',
    path: {
        symbol: data.symbol
    }
}); };

/**
 * @param data The data for the request.
 * @param data.symbol
 * @returns unknown OK
 * @throws ApiError
 */
export const adminProductControllerDeleteHorizontalProduct = (data: AdminProductControllerDeleteHorizontalProductData): CancelablePromise<AdminProductControllerDeleteHorizontalProductResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/products/horizontal/{symbol}',
    path: {
        symbol: data.symbol
    }
}); };

/**
 * @param data The data for the request.
 * @param data.symbol
 * @param data.requestBody
 * @returns HorizontalProductResponseDto OK
 * @throws ApiError
 */
export const adminProductControllerUpdateHorizontalProduct = (data: AdminProductControllerUpdateHorizontalProductData): CancelablePromise<AdminProductControllerUpdateHorizontalProductResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/admin/procurement/products/horizontal/{symbol}',
    path: {
        symbol: data.symbol
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.ppaId
 * @returns PowerPurchasingAgreementResponseDTO OK
 * @throws ApiError
 */
export const adminPowerPurchasingAgreementControllerGetPpa = (data: AdminPowerPurchasingAgreementControllerGetPpaData): CancelablePromise<AdminPowerPurchasingAgreementControllerGetPpaResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/ppas/{ppaId}',
    path: {
        ppaId: data.ppaId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.ppaId
 * @returns void No Content
 * @throws ApiError
 */
export const adminPowerPurchasingAgreementControllerDelete = (data: AdminPowerPurchasingAgreementControllerDeleteData): CancelablePromise<AdminPowerPurchasingAgreementControllerDeleteResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/ppas/{ppaId}',
    path: {
        ppaId: data.ppaId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.ppaId
 * @param data.requestBody
 * @returns PowerPurchasingAgreementResponseDTO OK
 * @throws ApiError
 */
export const adminPowerPurchasingAgreementControllerUpdateTranche = (data: AdminPowerPurchasingAgreementControllerUpdateTrancheData): CancelablePromise<AdminPowerPurchasingAgreementControllerUpdateTrancheResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/admin/procurement/ppas/{ppaId}',
    path: {
        ppaId: data.ppaId
    },
    body: data.requestBody,
    mediaType: 'application/json'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns StrategyResponseDTO OK
 * @throws ApiError
 */
export const strategyControllerRetrieveAllStrategies = (data: StrategyControllerRetrieveAllStrategiesData): CancelablePromise<StrategyControllerRetrieveAllStrategiesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/strategies',
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns StrategyResponseDTO OK
 * @throws ApiError
 */
export const strategyControllerGetStrategy = (data: StrategyControllerGetStrategyData): CancelablePromise<StrategyControllerGetStrategyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/strategies/{strategyId}',
    path: {
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.startDate
 * @param data.endDate
 * @returns ProductMarketTrackingDto OK
 * @throws ApiError
 */
export const marketTrackingControllerRetrieveMarketTrackingForAllProducts = (data: MarketTrackingControllerRetrieveMarketTrackingForAllProductsData): CancelablePromise<MarketTrackingControllerRetrieveMarketTrackingForAllProductsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/strategies/{strategyId}/tracking',
    path: {
        strategyId: data.strategyId
    },
    query: {
        startDate: data.startDate,
        endDate: data.endDate
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.tickerSymbol
 * @param data.startDate
 * @param data.endDate
 * @returns MarketTrackingDto OK
 * @throws ApiError
 */
export const marketTrackingControllerRetrieveMarketTracking = (data: MarketTrackingControllerRetrieveMarketTrackingData): CancelablePromise<MarketTrackingControllerRetrieveMarketTrackingResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/strategies/{strategyId}/tracking/{tickerSymbol}',
    path: {
        strategyId: data.strategyId,
        tickerSymbol: data.tickerSymbol
    },
    query: {
        startDate: data.startDate,
        endDate: data.endDate
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns SavingsCalculationResponseDTO OK
 * @throws ApiError
 */
export const savingsControllerGet = (data: SavingsControllerGetData): CancelablePromise<SavingsControllerGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/strategies/{strategyId}/savings',
    path: {
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.tickerSymbol
 * @param data.startDate
 * @param data.endDate
 * @param data.year
 * @param data.locationId
 * @param data.companyId
 * @returns BordersResponseDto OK
 * @throws ApiError
 */
export const borderControllerRetrieveBordersForInterval = (data: BorderControllerRetrieveBordersForIntervalData): CancelablePromise<BorderControllerRetrieveBordersForIntervalResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/strategies/{strategyId}/products/{tickerSymbol}/borders',
    path: {
        strategyId: data.strategyId,
        tickerSymbol: data.tickerSymbol
    },
    query: {
        startDate: data.startDate,
        endDate: data.endDate,
        locationId: data.locationId,
        companyId: data.companyId,
        year: data.year
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.granularity
 * @returns PortfolioBreakdownEntryDTO OK
 * @throws ApiError
 */
export const portfolioOverviewControllerGetPortfolioTimeseries = (data: PortfolioOverviewControllerGetPortfolioTimeseriesData): CancelablePromise<PortfolioOverviewControllerGetPortfolioTimeseriesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/strategies/{strategyId}/portfolio/timeseries',
    path: {
        strategyId: data.strategyId
    },
    query: {
        granularity: data.granularity
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns PortfolioOverviewDTO OK
 * @throws ApiError
 */
export const portfolioOverviewControllerGetPortfolioOverview = (data: PortfolioOverviewControllerGetPortfolioOverviewData): CancelablePromise<PortfolioOverviewControllerGetPortfolioOverviewResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/strategies/{strategyId}/portfolio/overview',
    path: {
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns PortfolioDistributionDTO OK
 * @throws ApiError
 */
export const portfolioOverviewControllerGetPortfolioDistribution = (data: PortfolioOverviewControllerGetPortfolioDistributionData): CancelablePromise<PortfolioOverviewControllerGetPortfolioDistributionResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/strategies/{strategyId}/portfolio/breakdown/products',
    path: {
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns MonthlyBreakdownResponseDTO OK
 * @throws ApiError
 */
export const portfolioOverviewControllerGetMonthlyDistribution = (data: PortfolioOverviewControllerGetMonthlyDistributionData): CancelablePromise<PortfolioOverviewControllerGetMonthlyDistributionResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/strategies/{strategyId}/portfolio/breakdown/months',
    path: {
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.fileId
 * @returns string OK
 * @throws ApiError
 */
export const strategyControllerGetStrategyDocuments = (data: StrategyControllerGetStrategyDocumentsData): CancelablePromise<StrategyControllerGetStrategyDocumentsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/strategies/{strategyId}/documents/{fileId}',
    path: {
        strategyId: data.strategyId,
        fileId: data.fileId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.fileId
 * @returns StrategyResponseDTO OK
 * @throws ApiError
 */
export const strategyControllerDeleteStrategyDocuments = (data: StrategyControllerDeleteStrategyDocumentsData): CancelablePromise<StrategyControllerDeleteStrategyDocumentsResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/procurement/strategies/{strategyId}/documents/{fileId}',
    path: {
        strategyId: data.strategyId,
        fileId: data.fileId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns StrategyOverviewTableRowDTO OK
 * @throws ApiError
 */
export const strategyControllerFetchStrategyOverviews = (data: StrategyControllerFetchStrategyOverviewsData): CancelablePromise<StrategyControllerFetchStrategyOverviewsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/strategies/overview',
    query: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.fileId
 * @returns string OK
 * @throws ApiError
 */
export const staticStrategyControllerGetStaticStrategyDocuments = (data: StaticStrategyControllerGetStaticStrategyDocumentsData): CancelablePromise<StaticStrategyControllerGetStaticStrategyDocumentsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/static/strategies/{strategyId}/documents/{fileId}',
    path: {
        strategyId: data.strategyId,
        fileId: data.fileId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.fileId
 * @returns StaticStrategyResponseDTO OK
 * @throws ApiError
 */
export const staticStrategyControllerDeleteStaticStrategyDocuments = (data: StaticStrategyControllerDeleteStaticStrategyDocumentsData): CancelablePromise<StaticStrategyControllerDeleteStaticStrategyDocumentsResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/procurement/static/strategies/{strategyId}/documents/{fileId}',
    path: {
        strategyId: data.strategyId,
        fileId: data.fileId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.startDate
 * @param data.endDate
 * @param data.energyType
 * @param data.granularity
 * @param data.companyId
 * @returns SpotPriceCurveResponseDTO OK
 * @throws ApiError
 */
export const spotPriceControllerGetSpotPriceCurve = (data: SpotPriceControllerGetSpotPriceCurveData): CancelablePromise<SpotPriceControllerGetSpotPriceCurveResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/spot-prices',
    query: {
        startDate: data.startDate,
        endDate: data.endDate,
        energyType: data.energyType,
        granularity: data.granularity,
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.tickerSymbol
 * @param data.startDate
 * @param data.endDate
 * @returns FuturePriceDTO OK
 * @throws ApiError
 */
export const pricesControllerRetrievePrices = (data: PricesControllerRetrievePricesData): CancelablePromise<PricesControllerRetrievePricesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/products/{tickerSymbol}/prices',
    path: {
        tickerSymbol: data.tickerSymbol
    },
    query: {
        startDate: data.startDate,
        endDate: data.endDate
    }
}); };

/**
 * @param data The data for the request.
 * @param data.startDate
 * @param data.endDate
 * @param data.market
 * @param data.period
 * @param data.periodType
 * @param data.productType
 * @param data.years
 * @param data.energyType
 * @returns ProductPricesDto OK
 * @throws ApiError
 */
export const pricesControllerGetAllProductPrices = (data: PricesControllerGetAllProductPricesData): CancelablePromise<PricesControllerGetAllProductPricesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/products/prices',
    query: {
        market: data.market,
        period: data.period,
        periodType: data.periodType,
        productType: data.productType,
        years: data.years,
        energyType: data.energyType,
        startDate: data.startDate,
        endDate: data.endDate
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns PlannedStrategyResponseDTO OK
 * @throws ApiError
 */
export const plannedStrategyControllerRetrievePlannedStrategy = (data: PlannedStrategyControllerRetrievePlannedStrategyData): CancelablePromise<PlannedStrategyControllerRetrievePlannedStrategyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/planned/strategies/{strategyId}',
    path: {
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns void No Content
 * @throws ApiError
 */
export const plannedStrategyControllerDeletePlannedStrategy = (data: PlannedStrategyControllerDeletePlannedStrategyData): CancelablePromise<PlannedStrategyControllerDeletePlannedStrategyResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/procurement/planned/strategies/{strategyId}',
    path: {
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.year
 * @param data.energyType
 * @param data.locationId
 * @param data.referenceDate
 * @param data.includeHourlyResults
 * @param data.include15MinResults
 * @returns LoadPlanningResponseDto OK
 * @throws ApiError
 */
export const loadPlanningControllerGetForecast = (data: LoadPlanningControllerGetForecastData): CancelablePromise<LoadPlanningControllerGetForecastResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/forecasts',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        year: data.year,
        energyType: data.energyType,
        referenceDate: data.referenceDate,
        includeHourlyResults: data.includeHourlyResults,
        include15MinResults: data.include15MinResults
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.energyType
 * @param data.year
 * @returns EarliestConsumptionPerLocationDTO OK
 * @throws ApiError
 */
export const loadPlanningControllerGetEarliestConsumptionPerLocation = (data: LoadPlanningControllerGetEarliestConsumptionPerLocationData): CancelablePromise<LoadPlanningControllerGetEarliestConsumptionPerLocationResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/earliest-consumption',
    query: {
        companyId: data.companyId,
        energyType: data.energyType,
        year: data.year
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.year
 * @param data.energyType
 * @param data.locationId
 * @param data.status
 * @returns AllAdjustmentsResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerFindAllAdjustments = (data: LoadAdjustmentsControllerFindAllAdjustmentsData): CancelablePromise<LoadAdjustmentsControllerFindAllAdjustmentsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/adjustments',
    query: {
        locationId: data.locationId,
        companyId: data.companyId,
        year: data.year,
        energyType: data.energyType,
        status: data.status
    }
}); };

/**
 * @param data The data for the request.
 * @param data.measureSimulationId
 * @param data.measureId
 * @returns AllAdjustmentsResponseDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerFindAdjustmentsByMeasureSimulation = (data: LoadAdjustmentsControllerFindAdjustmentsByMeasureSimulationData = {}): CancelablePromise<LoadAdjustmentsControllerFindAdjustmentsByMeasureSimulationResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/adjustments/measure-simulation',
    query: {
        measureSimulationId: data.measureSimulationId,
        measureId: data.measureId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @param data.year
 * @returns MeasureSimulationCandidateDTO OK
 * @throws ApiError
 */
export const loadAdjustmentsControllerFindAllMeasureSimulationCandidates = (data: LoadAdjustmentsControllerFindAllMeasureSimulationCandidatesData): CancelablePromise<LoadAdjustmentsControllerFindAllMeasureSimulationCandidatesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/load-planning/adjustments/measure-simulation-candidates',
    query: {
        companyId: data.companyId,
        year: data.year
    }
}); };

/**
 * @deprecated
 * @param data The data for the request.
 * @param data.companyId
 * @returns CompanyConfigDto OK
 * @throws ApiError
 */
export const companyFrontendConfigurationControllerGetCompanyConfiguration = (data: CompanyFrontendConfigurationControllerGetCompanyConfigurationData): CancelablePromise<CompanyFrontendConfigurationControllerGetCompanyConfigurationResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/frontendFlags/{companyId}',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns CompanyConfigDto OK
 * @throws ApiError
 */
export const companyFrontendConfigurationsControllerGetCompanyConfiguration = (data: CompanyFrontendConfigurationsControllerGetCompanyConfigurationData): CancelablePromise<CompanyFrontendConfigurationsControllerGetCompanyConfigurationResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/company-frontend-configurations/{companyId}',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns CompanyRetoolDashboardUrlDto OK
 * @throws ApiError
 */
export const companyFrontendConfigurationsControllerGetRetoolDashboardUrl = (data: CompanyFrontendConfigurationsControllerGetRetoolDashboardUrlData): CancelablePromise<CompanyFrontendConfigurationsControllerGetRetoolDashboardUrlResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/procurement/company-frontend-configurations/{companyId}/retool-dashboard-url',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.trancheId
 * @returns StatusChangeDTO OK
 * @throws ApiError
 */
export const adminTrancheFixingStatusControllerGetTrancheHistory = (data: AdminTrancheFixingStatusControllerGetTrancheHistoryData): CancelablePromise<AdminTrancheFixingStatusControllerGetTrancheHistoryResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/tranche-fixing/statuses/{trancheId}/history',
    path: {
        trancheId: data.trancheId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.from
 * @param data.until
 * @returns HistoryResponseDTO OK
 * @throws ApiError
 */
export const adminTrancheFixingStatusControllerGetHistory = (data: AdminTrancheFixingStatusControllerGetHistoryData = {}): CancelablePromise<AdminTrancheFixingStatusControllerGetHistoryResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/tranche-fixing/history',
    query: {
        from: data.from,
        until: data.until
    }
}); };

/**
 * @param data The data for the request.
 * @param data.eligibility
 * @param data.supplierNames
 * @param data.productSymbols
 * @param data.companyIds
 * @param data.statusKeys
 * @param data.serviceModels
 * @param data.year
 * @param data.energyType
 * @returns TrancheFixingBoardResponseDTO OK
 * @throws ApiError
 */
export const adminTrancheFixingBoardControllerGetBoard = (data: AdminTrancheFixingBoardControllerGetBoardData = {}): CancelablePromise<AdminTrancheFixingBoardControllerGetBoardResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/tranche-fixing/board',
    query: {
        eligibility: data.eligibility,
        supplierNames: data.supplierNames,
        productSymbols: data.productSymbols,
        companyIds: data.companyIds,
        statusKeys: data.statusKeys,
        serviceModels: data.serviceModels,
        year: data.year,
        energyType: data.energyType
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @param data.granularity
 * @returns HedgedSummaryTimeSeriesDTO OK
 * @throws ApiError
 */
export const adminStrategyControllerGetHedgedSummaryTimeseries = (data: AdminStrategyControllerGetHedgedSummaryTimeseriesData): CancelablePromise<AdminStrategyControllerGetHedgedSummaryTimeseriesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/strategies/{strategyId}/hedgedSummaryTimeSeries',
    path: {
        strategyId: data.strategyId
    },
    query: {
        granularity: data.granularity
    }
}); };

/**
 * @returns string OK
 * @throws ApiError
 */
export const adminProductControllerRetrieveTickerSymbols = (): CancelablePromise<AdminProductControllerRetrieveTickerSymbolsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/products/tickers'
}); };

/**
 * @returns ReferencePriceResponseDto OK
 * @throws ApiError
 */
export const adminReferencePriceControllerRetrieveAllReferencePrices = (): CancelablePromise<AdminReferencePriceControllerRetrieveAllReferencePricesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/prices/reference'
}); };

/**
 * @deprecated
 * @returns CompanyConfigDto OK
 * @throws ApiError
 */
export const adminCompanyFrontendConfigurationControllerGetAllCompanyConfigurations = (): CancelablePromise<AdminCompanyFrontendConfigurationControllerGetAllCompanyConfigurationsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/frontendFlags'
}); };

/**
 * @returns CompanyConfigDto OK
 * @throws ApiError
 */
export const adminCompanyFrontendConfigurationsControllerGetAllCompanyConfigurations = (): CancelablePromise<AdminCompanyFrontendConfigurationsControllerGetAllCompanyConfigurationsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/company-frontend-configurations'
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns CompanyRetoolDashboardUrlDto OK
 * @throws ApiError
 */
export const adminCompanyFrontendConfigurationsControllerGetRetoolDashboardUrls = (data: AdminCompanyFrontendConfigurationsControllerGetRetoolDashboardUrlsData): CancelablePromise<AdminCompanyFrontendConfigurationsControllerGetRetoolDashboardUrlsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/company-frontend-configurations/{companyId}/retool-dashboard-urls',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns CompanyContactedStrategiesDto OK
 * @throws ApiError
 */
export const adminCompanyFrontendConfigurationsControllerGetContactedStrategies = (data: AdminCompanyFrontendConfigurationsControllerGetContactedStrategiesData): CancelablePromise<AdminCompanyFrontendConfigurationsControllerGetContactedStrategiesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/admin/procurement/company-frontend-configurations/{companyId}/contacted-strategies',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void No Content
 * @throws ApiError
 */
export const loadAdjustmentsControllerDeleteAdjustment = (data: LoadAdjustmentsControllerDeleteAdjustmentData): CancelablePromise<LoadAdjustmentsControllerDeleteAdjustmentResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/procurement/load-planning/adjustments/{id}',
    path: {
        id: data.id
    }
}); };

/**
 * @param data The data for the request.
 * @param data.utilityName
 * @param data.serviceModel
 * @returns void No Content
 * @throws ApiError
 */
export const adminTrancheFixingConfigControllerDeleteWorkflow = (data: AdminTrancheFixingConfigControllerDeleteWorkflowData): CancelablePromise<AdminTrancheFixingConfigControllerDeleteWorkflowResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/tranche-fixing/config/{utilityName}/{serviceModel}',
    path: {
        utilityName: data.utilityName,
        serviceModel: data.serviceModel
    }
}); };

/**
 * @param data The data for the request.
 * @param data.year
 * @param data.energySource
 * @returns void No Content
 * @throws ApiError
 */
export const energySourcePriceControllerDeleteEnergySourcePrice = (data: EnergySourcePriceControllerDeleteEnergySourcePriceData): CancelablePromise<EnergySourcePriceControllerDeleteEnergySourcePriceResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/energy-source/reference/{energy-source}/{year}',
    path: {
        year: data.year,
        'energy-source': data.energySource
    }
}); };

/**
 * @param data The data for the request.
 * @param data.utilityName
 * @returns void No Content
 * @throws ApiError
 */
export const adminUtilityContactConfigControllerDeleteUtilityInfo = (data: AdminUtilityContactConfigControllerDeleteUtilityInfoData): CancelablePromise<AdminUtilityContactConfigControllerDeleteUtilityInfoResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/config/utility/{utilityName}',
    path: {
        utilityName: data.utilityName
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns void No Content
 * @throws ApiError
 */
export const adminCompanyTrackingAlgorithmOverrideControllerDeleteCompanyAlgorithmOverride = (data: AdminCompanyTrackingAlgorithmOverrideControllerDeleteCompanyAlgorithmOverrideData): CancelablePromise<AdminCompanyTrackingAlgorithmOverrideControllerDeleteCompanyAlgorithmOverrideResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/config/tracking-algorithm-overrides/{companyId}',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns void No Content
 * @throws ApiError
 */
export const adminCompanyNotificationConfigControllerDeleteCompanyNotificationConfig = (data: AdminCompanyNotificationConfigControllerDeleteCompanyNotificationConfigData): CancelablePromise<AdminCompanyNotificationConfigControllerDeleteCompanyNotificationConfigResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/config/notifications/{companyId}',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns void No Content
 * @throws ApiError
 */
export const adminStrategyNotificationConfigControllerDeleteStrategyNotificationConfig = (data: AdminStrategyNotificationConfigControllerDeleteStrategyNotificationConfigData): CancelablePromise<AdminStrategyNotificationConfigControllerDeleteStrategyNotificationConfigResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/config/notifications/strategies/{strategyId}',
    path: {
        strategyId: data.strategyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns void No Content
 * @throws ApiError
 */
export const adminCompanyHedgerConfigControllerDeleteCompanyHedgerConfig = (data: AdminCompanyHedgerConfigControllerDeleteCompanyHedgerConfigData): CancelablePromise<AdminCompanyHedgerConfigControllerDeleteCompanyHedgerConfigResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/config/hedger/{companyId}',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.companyId
 * @returns void No Content
 * @throws ApiError
 */
export const adminCompanyFrontendConfigurationsControllerDeleteCompanyConfiguration = (data: AdminCompanyFrontendConfigurationsControllerDeleteCompanyConfigurationData): CancelablePromise<AdminCompanyFrontendConfigurationsControllerDeleteCompanyConfigurationResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/company-frontend-configurations/{companyId}',
    path: {
        companyId: data.companyId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.trancheId
 * @returns TrancheBuySignalNotificationResetResponseDTO OK
 * @throws ApiError
 */
export const adminBuySignalNotificationControllerResetForTranche = (data: AdminBuySignalNotificationControllerResetForTrancheData): CancelablePromise<AdminBuySignalNotificationControllerResetForTrancheResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/buy-signal-notifications/tranche/{trancheId}',
    path: {
        trancheId: data.trancheId
    }
}); };

/**
 * @param data The data for the request.
 * @param data.strategyId
 * @returns StrategyBuySignalNotificationResetResponseDTO OK
 * @throws ApiError
 */
export const adminBuySignalNotificationControllerResetForStrategy = (data: AdminBuySignalNotificationControllerResetForStrategyData): CancelablePromise<AdminBuySignalNotificationControllerResetForStrategyResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/admin/procurement/buy-signal-notifications/strategy/{strategyId}',
    path: {
        strategyId: data.strategyId
    }
}); };